module.exports = __webpack_public_path__ + "img/credit-card-compare.50fcff1.png";